import { render, staticRenderFns } from "./MetasTabela.vue?vue&type=template&id=4b55b769"
import script from "./MetasTabela.vue?vue&type=script&lang=js"
export * from "./MetasTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports